import { HttpResponse } from 'msw';

import { genBookingDataDoctor, genDoctorBookingSchedule } from '@/shared/lib/msw/generators/doctor';

export const getDoctorBookingOnline = () => {
  return HttpResponse.json(
    {
      data: genBookingDataDoctor({
        doctorId: 1224125,
        medcenterId: 883,
        onlineBooking: {
          iinRequired: false,
          schedule: genDoctorBookingSchedule({
            isWork: [1, 2, 3, 4, 5, 6],
            is24HoursWork: 'none',
            sessionDuration: 30,
            startHour: [8, 12, 9, 10, 8, 11],
            endHour: [14, 18, 17, 16, 15, 19],
          }),
          timeslotsIsEmpty: false,
          basedOn: 'manual',
        },
      }),
    },
    { status: 200 },
  );
};

export const getDoctorBookingForPreferredTime = () => {
  return HttpResponse.json(
    {
      data: genBookingDataDoctor({
        doctorId: 1223993,
        medcenterId: 120,
        onlineBooking: {
          iinRequired: false,
          schedule: null,
          timeslotsIsEmpty: true,
          basedOn: 'preferred_time',
        },
      }),
    },
    { status: 200 },
  );
};
